export default __webpack_public_path__ + "static/media/info.87895e5a.svg";